import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth';
import tests from './modules/tests';
import base from './modules/base';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    base,
    auth,
    tests
  }
})
